export default __webpack_public_path__ + "static/media/flip.d4087d2e.svg";